/**
 * Router location state when navigating to `/garage/:id` so the detail page
 * "back" link returns to profile, another user's garage list, etc.
 */
export type GarageCarNavState = {
  garageBack?: string;
};

/** Accept only same-origin path-style URLs (no open redirects). */
export function parseGarageBackPath(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const t = value.trim();
  if (!t.startsWith('/') || t.startsWith('//')) return undefined;
  if (t.includes('://') || /[\r\n]/.test(t)) return undefined;
  return t;
}

export function garageBackLinkLabel(path: string): string {
  if (path === '/garage') return 'Garage';
  if (path.startsWith('/user/')) return 'Profile';
  if (path.startsWith('/garages/user/')) return 'Garage';
  return 'Back';
}
